import appApis, { APP_QUERY_TAG } from '@/store/apis/app';
import { IAppCustomer } from '@/types/api/app/customer';
import { MutationParams } from '@/types/api/common';

const appCustomersApis = appApis.injectEndpoints({
  endpoints: (build) => ({
    // customer
    updateCustomerPersonalProfile: build.mutation<
      void,
      MutationParams<Partial<IAppCustomer>, { customerId: number }>
    >({
      query: ({ body, params }) => {
        const { customerId } = params;

        return {
          url: `/customers/${customerId}`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [APP_QUERY_TAG.customerMe],
    }),

    redeemGiftCardCode: build.mutation<
      void,
      { code: string; customerId: number }
    >({
      query: ({ code, customerId }) => {
        return {
          url: `/customers/${customerId}/redeem-gift-card`,
          method: 'PATCH',
          body: {
            giftCardCode: code,
          },
        };
      },
      invalidatesTags: [APP_QUERY_TAG.customerMe],
    }),
  }),
});

export const {
  useUpdateCustomerPersonalProfileMutation,
  useRedeemGiftCardCodeMutation,
} = appCustomersApis;

export default appCustomersApis;
